// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__GeG2E","large":"styles_large__1T20d"};